import React, { useState, useEffect, useRef } from 'react'
import './SplashScreen.scss'; // Optional: Use CSS for styling
import useAuth from 'hooks/useAuth'
const SplashScreen = () => {
    const {user,config,isLoggedIn} = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(()=>{
        //Timeout
        setTimeout(()=>{
            hideSplash();
        },5000)

    },[])

    useEffect(()=>{
        if(config && user && isLoggedIn){
            //setTimeout(()=>{
                hideSplash()
          //  }, 2000)            
        }
    },[config,user])

    const hideSplash = ()=>{
        window.ckdStartup?.complete();
        const element = document.getElementById('public-splash-screen');
                if(element)
                    element.style.display = 'none';
    }

    if(!isLoading){
        return null;
    }
    return (
        <div className="splash-screen">
            <div className='login-pf-page'>
                <div id="kc-header" class="login-pf-page-header">

                    <div class="logo">
                        <img alt="CkDoctor" src="logo/logo-white-256.png" width="256"></img>                        
                    </div>
                </div>
                <div class="card-pf">
                    <header class="login-pf-header">
                        <h1 id="kc-page-title">    CK-Doctor</h1>
                        <h1 id="kc-page-title">    Loading...</h1>
                    </header>
    

                </div>
            </div>

            {/* Add any other loading indicators or branding */}
        </div>
    );
};

export default SplashScreen;